import React from 'react';
import { AboutPageLayout } from '../Layout';
import styles from './What.module.scss';

export const WhatStepOneSection = () => (
  <AboutPageLayout
    leftContent={
      <div className={styles.leftSection}>
        <div className={styles.stepSection_1}>What</div>
        <div className={styles.stepSection_2}>is</div>
        <div className={styles.stepSection_3}>
          Transparen <br /> Terra?
        </div>
      </div>
    }
    rightContent={
      <div className={styles.stepContent}>
        TransparenTerra is a cloud platform that makes sustainability efforts measurable and
        improvable. Progressive digital initiatives and the circular economy projects become visible
        and notable. An ESG calculator, blockchain-based solutions, and other digital tools
        guarantee a trustworthy environment and secure vibe.
      </div>
    }
  />
);
